






























































import { Vue, Component, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { DelegateObjectTypes } from "@/data/enums/delegates";
import { IContractProduct } from "@/models/contracts";
import { ITicket } from "@/models/tickets";
import { Route } from "vue-router";
import _ from "@/boot/lodash";
import { IDelegate } from "@/models/delegates";
import { TranslateResult } from "vue-i18n";

@Component
export default class AcceptInviteModal extends Vue {
  // Props
  @Prop({ required: true })
  public hash!: string;

  // Data

  public hasError = false;
  public hasAccepted = false;

  public objectType: string | TranslateResult = "";
  public objectRoute: Route | null = null;
  public objectIdentifier = "";
  public objectMap = {
    [DelegateObjectTypes.CONTRACT_PRODUCT]: {
      label: this.$t("_.product"),
      identifier: (cProd: IContractProduct) => cProd.product_name,
      route: (cProd: IContractProduct) => ({
        name: "clientCProd",
        params: {
          contractId: cProd.contract_id,
          productId: cProd.id
        }
      })
    },
    [DelegateObjectTypes.TICKET]: {
      label: this.$t("_.ticket"),
      identifier: (ticket: ITicket) => ticket.reference,
      route: (ticket: ITicket) => ({
        name: "clientSupportTicket",
        params: {
          ticketId: ticket.id
        }
      })
    }
  };

  // Life-cycle methods

  public created() {
    this.acceptInvite();
  }

  // Methods

  public async acceptInvite() {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [delay, result]: [any, IDelegate] = await Promise.all([
        // Add a small delay for improved UX
        new Promise(resolve => setTimeout(resolve, 2000)) as any,
        // Accept invite
        this.$store.dispatch(
          `data/${DataModules.DELEGATES}/acceptInvite`,
          this.hash
        )
      ]);
      const mappedObj = _.get(this.objectMap, result.object_type);
      this.objectType = mappedObj.label;
      this.objectRoute = (mappedObj.route(result.object) as unknown) as Route;
      this.objectIdentifier = mappedObj.identifier(result.object);
      // Update accepted flag
      this.hasAccepted = true;
    } catch (error) {
      this.hasError = true;
      this.$store.dispatch("api/handleError", error);
    }
  }
}
